import { useCallback, useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';
import { BigNumber, providers } from 'ethers';
import { getBalanceInEther } from 'utils';

import { useToken } from './useContract';

export const useTokenBalance = (address: string, tokenChainId: number) => {
  const [balance, setBalance] = useState<BigNumber>(BigNumber.from(0));

  const { account, chainId, connector } = useWeb3React();
  const tokenContract = useToken(address);

  const fetchBalance = useCallback(async () => {
    if (!account) return;
    if (!chainId) return;
    if (!tokenContract) return;
    if( chainId !== tokenChainId ) return;

    const provider = new providers.Web3Provider(connector.provider!);
    const rawBalance = await tokenContract.balanceOf(account);
    setBalance(rawBalance);
  }, [account, chainId, connector, tokenContract, tokenChainId]);

  useEffect(() => {
    fetchBalance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, chainId]);

  useEffect(() => {
    fetchBalance();

    setTimeout(() => {
      fetchBalance();
    }, 30000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return balance;
};
